import axios from 'axios';

import { GET_ERRORS, FILTER_ACCOMMODATIONS, FILTER_TOURS, CLEAR_FILTER } from './types';
import { API_ENDPOINT } from "../config/constants";

export const filterAccommodations = (filterData, history=null) => dispatch => {
    console.log(API_ENDPOINT+`/accomodations/search?location=${filterData.location}&start=${filterData.checkIn}&end=${filterData.checkOut}&persons=${filterData.numPersons}&full_lease=${filterData.full_lease}`);
    axios.get(API_ENDPOINT+`/accomodations/search?location=${filterData.location}&start=${filterData.checkIn}&end=${filterData.checkOut}&persons=${filterData.numPersons}&full_lease=${filterData.full_lease}`)
        .then(res => {
            dispatch({
                type: FILTER_ACCOMMODATIONS,
                payload: res.data.accomodations,
                searchDataAccomm: filterData
            });

            if (history!==null) { // From Landing Page
                history.push({ pathname: '/accommodations', state: { message: 'Alojamientos filtrados exitosamente', type: 'success' } })
            }
        })
        .catch(err =>
            dispatch({
                type: GET_ERRORS,
                payload: err.response.data
            })
        );
};

export const filterTours = (filterData, history=null) => dispatch => {
    console.log(API_ENDPOINT+`/tours/search?start=${filterData.checkIn}&end=${filterData.checkOut}&persons=${filterData.numPersons}`);
    axios.get(API_ENDPOINT+`/tours/search?start=${filterData.checkIn}&end=${filterData.checkOut}&persons=${filterData.numPersons}`)
        .then(res => {
            dispatch({
                type: FILTER_TOURS,
                payload: res.data.tours,
                searchDataTour: filterData
            });

            if (history!==null) { // From Landing Page
                history.push({ pathname: '/tours', state: { message: 'Tours filtrados exitosamente', type: 'success' } })
            }
        })
        .catch(err =>
            dispatch({
                type: GET_ERRORS,
                payload: err.response.data
            })
        );
};

export const clearFilter = () => {
    return {
        type: CLEAR_FILTER
    }
};


// WEBPACK FOOTER //
// ./src/actions/filterActions.js